import React from "react";

const Pitchdeck = ({ activity }) => {
  return (
    <>
      {activity ? (
        <>
          <table className="plan_table mt-24">
            <thead className="plan_thead activityplan_thead">
              <tr>
                <th className="">User</th>
                <th className="">Title</th>
                <th className="">Industry</th>
                <th className="">Time</th>
              </tr>
            </thead>
            {activity.length > 0 &&
              activity.map((res, i) => (
                <tr key={i} className="my-2 pt-2">
                  <td className=" my-2 pt-2">
                    {`${res.userId.name} (${res.userId.email})`}
                  </td>
                  <td className=" my-2 pt-2">{res.name}</td>
                  <td className=" my-2 pt-2">{res.industry}</td>
                  <td className="">
                    {new Date(res.updatedAt).toLocaleTimeString()}{" "}
                    {new Date(res.updatedAt).toLocaleDateString()}
                  </td>
                </tr>
              ))}
          </table>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default Pitchdeck;
